app.factory("policySumm", ['$q', '$filter', '$rootScope', 'httpService', function ($q, $filter, $rootScope, httpService) {
    return ({
        getPolicyCount: getPolicyCount,
        getPolicySummary: getPolicySummary,
        getPolicySummaryRecently: getPolicySummaryRecently,
        getPolicyDetails: getPolicyDetails,
        
    });
    function getPolicyCount(count, page, searchKey, policyStatuses, jurisdiction, isExcludeInactivePolicy) {
        $rootScope.PolicyPageCount = [];
        var searchString = $filter('undefined')(searchKey) ? "" : searchKey;
        var APITarget = "api/vicpolicies/getvicpoliciescount";

        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            RowsPerPage: count,
            Keyword: searchString,
            BusinessUnit: $rootScope.combineJurisdiction([jurisdiction]),
            PolicyStatus: policyStatuses || [],
            IsExcludeInactivePolicy: isExcludeInactivePolicy
        });
        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve(0);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    $rootScope.PolicyCount = $rootScope.serverResponse;
                    if($rootScope.PolicyCount === 1 || (policyStatuses && policyStatuses.length > 0)) {
                        var APITarget = "api/vicpolicies/getvicpoliciessummary";
                        requestGetListPolicy($rootScope.policyPageSelected, count, searchKey, APITarget, jurisdiction, policyStatuses, isExcludeInactivePolicy).finally(function (data) {
                            defer.resolve($rootScope.PolicyCount);        
                        }); 
                    } else 
                        defer.resolve($rootScope.PolicyCount);
                }
            }//if data==false
            else
                defer.resolve(0);
        });

        return defer.promise;

    }//end getPolicyCount()

    function getPolicySummary(num, count, searchKey, jurisdiction, isExcludeInactivePolicy) {
        var searchString = $filter('undefined')(searchKey) ? "" : searchKey;
        var APITarget = "api/vicpolicies/getvicpoliciessummary";
        return requestGetListPolicy(num, count, searchKey, APITarget, jurisdiction, [] ,isExcludeInactivePolicy);
    }//end getPolicySummary

    function getPolicySummaryRecently(num, count, searchKey, jurisdiction, isExcludeInactivePolicy) {
        var APITarget = "api/vicpolicies/getrecentworkedvicpolicies";

        return requestGetListPolicy(num, count, searchKey, APITarget, jurisdiction, [],  isExcludeInactivePolicy);
    }//end getPolicySummaryRecently


    function requestGetListPolicy(num, count, searchKey, APITarget, jurisdiction, policyStatuses, isExcludeInactivePolicy) {
        var searchString = $filter('undefined')(searchKey) ? "" : searchKey;

        var listJurisdiction = (jurisdiction !== undefined && jurisdiction !== null)? [jurisdiction] : [];
        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            RowsPerPage: count,
            PageNumber: num,
            Keyword: searchString,
            IsExcludeExpirePolicy: true,
            IsExcludeInactivePolicy: isExcludeInactivePolicy,
            BusinessUnit: $rootScope.combineJurisdiction(listJurisdiction),
            PolicyStatus: policyStatuses || []
        });
        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    $rootScope.Policies = $rootScope.serverResponse;           
                    // Check this to show message announce that there is no policy
                    if ($rootScope.Policies.PolicyList == null || $rootScope.Policies.PolicyList.length == 0) {
                        $rootScope.hasResult = false;
                    }
                    else {
                        $rootScope.hasResult = true;
                        $rootScope.pageNavigationHistory.policy = { PolicyId: $rootScope.Policies.PolicyList[0].EmployerId };
                    }
                    defer.resolve($rootScope.Policies);
                }
                //alert($filter('decstr64')(data));
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    function getPolicyDetails(policyID) {
        var APITarget = "api/policies/viewpolicydetail";
        var Values = '{'
            + '"Identifier" : "' + $rootScope.user.Identifier + '",'
            + '"SessionKey"  : "' + $filter('decstr64')($rootScope.user.SessionKey) + '",'
            + '"PolicyId" : "' + policyID
            + '"}';

        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                }
                $rootScope.PolicyDetails = angular.fromJson(data);
                return $rootScope.PolicyDetails;
            }

        });
    }//end getPolicySummary

}]);//end policySumm

app.factory("claimSumm", ['$http', '$q', '$filter', '$rootScope', '$timeout', 'httpService', function ($http, $q, $filter, $rootScope, $timeout, httpService) {
    return ({
        getClaimantSummary: getClaimantSummary,
        getClaimDetails: getClaimDetails,
        getNationalClaimDetails: getNationalClaimDetails,
        getEmlContactDetails: getEmlContactDetails,
        getClaimList: getClaimList,
        getClaimCount: getClaimCount,
        getClaimListByIdentifier: getClaimListByIdentifier,
        getClaimCountByIdentifier: getClaimCountByIdentifier,
        getWorkerClaimNumbers: getWorkerClaimNumbers,
        getNeedReviewClaimCount : getNeedReviewClaimCount,
        submitClaimReview: submitClaimReview,
        checkClaimReview: checkClaimReview,
        cancelBlockClaimReview: cancelBlockClaimReview
    });
    function getClaimantSummary() {
        var deferred = $q.defer();

        getEmlContactDetails();
        var APITarget = "api/claims/viewclaimsummary";
        var values = {
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey)
        };

        var ValuesAsString = JSON.stringify(values);

        httpService.httpRequest(APITarget, ValuesAsString)
            .then(function (data) {  // this is only run after $http completes
                if (data != false) {
                    if (data == "logout") {
                        $rootScope.userLogout();
                    }
                    var serverResponse = angular.fromJson(data);
                    $rootScope.MyClaims = serverResponse;
                    for (var i = 0; i < $rootScope.MyClaims.ClaimList.length; i++) {
                        var claimTotal = {
                            claimTitle: $rootScope.MyClaims.ClaimList[i],
                            claimDetails: ""
                        };

                        $rootScope.MyClaimsContents.push(claimTotal);
                        $rootScope.MyClaimsContents[i].visible = false;
                    }
                    deferred.resolve(true);
                }

                deferred.reject(false);
            });

        return deferred.promise;
    }//end getClaimantSummary()

    function getClaimDetails(claimId) {
        var deferred = $q.defer();

        var APITarget = "api/claims/viewclaimdetail";
        var Values = '{'
            + '"Identifier" : "' + $rootScope.user.Identifier + '",'
            + '"SessionKey"  : "' + $filter('decstr64')($rootScope.user.SessionKey) + '",'
            + '"ClaimId" : "' + claimId
            + '"}';

        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                }
                var serverResponse = angular.fromJson(data);
                $rootScope.MyClaimsDetails = serverResponse;
                deferred.resolve(true);
            }

            deferred.reject(false);
        });

        return deferred.promise;
    }

    function getNationalClaimDetails(claimId) {
        var deferred = $q.defer();

        var APITarget = "api/vicclaims/getvicclaimdetail";
        var Values = '{'
            + '"Identifier" : "' + $rootScope.user.Identifier + '",'
            + '"SessionKey"  : "' + $filter('decstr64')($rootScope.user.SessionKey) + '",'
            + '"ClaimId" : "' + claimId + '",'
            + '"DateOfBirth" : "' + $rootScope.user.DateOfBirth + '",'
            + '"IsClaimant" : "' + $rootScope.IsClaimant
            + '"}';

        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                }
                var serverResponse = angular.fromJson(data);
                deferred.resolve(serverResponse);
            }

            deferred.reject([]);
        });

        return deferred.promise;
    }

    function getEmlContactDetails() {

        var APITarget = "api/common/getclaimscontactinfo";
        var Values = "";
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                }
                var serverResponse = angular.fromJson(data);
                $rootScope.EMLContacts = serverResponse;
                return $rootScope.EMLContacts;
                //alert($filter('decstr64')(data));
            }//if data==false
        });//httpService

    }//end getEmlContactDetails()

    function getClaimList(num, count, employerId, searchKey) {
        var APITarget = 'api/vicclaims/getvicclaimsummary';
        var searchString = $filter('undefined')(searchKey) ? "" : searchKey;

        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            RowsPerPage: count,
            PageNumber: num,
            EmployerId: employerId,
            Keyword: searchString,
            IsExcludeExpirePolicy: true,
            IsClaimant: $rootScope.IsClaimant
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    $rootScope.ClaimList = $rootScope.serverResponse;
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    // sortBy: 1 >>> recentActivity; 2 >>> recent injury date
    function getClaimListByIdentifier(num, count, searchKey, sortBy, jurisdiction) {
        var APITarget = "api/vicclaims/getvicclaimsummarybyidentifier";
        var listJurisdiction = jurisdiction? [jurisdiction] : [];
        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            Keyword: searchKey,
            RowsPerPage: count,
            PageNumber: num,
            IsFirstSearch: false,
            BusinessUnit: $rootScope.combineJurisdiction(listJurisdiction),
            SortBy: sortBy,
            IsClaimant: $rootScope.IsClaimant,
            IsNsiUser: $rootScope.user.IsNsiUser
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    // sortBy: 1 >>> recentActivity; 2 >>> recent injury date
    function getClaimCountByIdentifier(num, count, searchKey, sortBy, jurisdiction){
        var APITarget = "api/vicclaims/getvicclaimsummarybyidentifiercount";
        var listJurisdiction = jurisdiction? [jurisdiction] : [];
        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            Keyword: searchKey,
            RowsPerPage: count,
            PageNumber: num,
            IsFirstSearch: false,
            BusinessUnit: $rootScope.combineJurisdiction(listJurisdiction),
            SortBy: sortBy,
            IsClaimant: $rootScope.IsClaimant,
            IsNsiUser: $rootScope.user.IsNsiUser
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false || !isNaN(parseInt(data))) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    function getClaimCount(num, count, employerId, searchKey) {
        var APITarget = 'api/vicclaims/getvicclaimscount';
        var searchString = $filter('undefined')(searchKey) ? "" : searchKey;

        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            RowsPerPage: count,
            PageNumber: num,
            EmployerId: employerId,
            Keyword: searchString,
            IsExcludeExpirePolicy: true,
            IsClaimant: $rootScope.IsClaimant
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    $rootScope.ClaimCount = $rootScope.serverResponse;
                    if($rootScope.ClaimCount === 1) {
                        getClaimList(1, count, employerId, searchKey).finally(function (data) {
                            defer.resolve($rootScope.ClaimCount);
                        }); 
                    } else 
                        defer.resolve($rootScope.ClaimCount);
                    
                }
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    function getWorkerClaimNumbers() {
        var APITarget = "api/vicclaims/getworkerclaimnumbers";
        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve([]);
            }
        });
        return defer.promise;
    }

    function getNeedReviewClaimCount(clientId) {
        var APITarget = "api/claims/getneedReviewclaimcount";
        var Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            clientId: clientId
        });

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve(0);
            }
        });
        return defer.promise;
    }

    function submitClaimReview(claimReview) {
        var APITarget = "api/claims/reviewClaim";
        var Values = JSON.stringify(claimReview);

        var defer = $q.defer();
        httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {  // this is only run after $http completes
            if (data != false) {
                if (data == "logout") {
                    $rootScope.userLogout();
                    defer.resolve([]);
                }
                else {
                    $rootScope.serverResponse = angular.fromJson(data);
                    defer.resolve($rootScope.serverResponse);
                }
            }//if data==false
            else {
                defer.resolve(0);
            }
        }, function (err) {
            void 0;
            defer.reject(err);
        });
        return defer.promise;
    }

    function checkClaimReview(claimId) {
        var def = $q.defer(),
        APITarget = "api/claims/checkClaimReview",
        Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            IsClaimant: $rootScope.user.IsClaimant,
            ClaimId: claimId
        });

        httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {
            if (data !== false) {
                if (data === "logout") {
                    $rootScope.userLogout();
                }
                def.resolve(angular.fromJson(data)); 
            } else {
                def.reject();
            }
        });

        return def.promise;
    }

    function cancelBlockClaimReview(claimId) {
        var def = $q.defer(),
        APITarget = "api/claims/cancelBlockClaimReview",
        Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            IsClaimant: $rootScope.user.IsClaimant,
            ClaimId: claimId
        });

        httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {
            if (data !== false) {
                if (data === "logout") {
                    $rootScope.userLogout();
                }
                def.resolve(angular.fromJson(data)); 
            } else {
                def.reject();
            }
        });

        return def.promise;
    }
}])//end policySumm

app.factory("dropdownService", ['$q', '$filter', '$rootScope', 'httpService', function ($q, $filter, $rootScope, httpService) {
    return ({
        searchCostCenters: searchCostCenters,
        searchDepartments: searchDepartments,
        searchBusinessUnits: searchBusinessUnits
    });

    function searchCostCenters(pageNumber, rowsPerPage, keyword) {
        var def = $q.defer(),
        APITarget = "api/costcenter/searchCostCenters",
        Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            IsClaimant: $rootScope.user.IsClaimant,
            PageNumber: pageNumber,
            RowsPerPage: rowsPerPage,
            Keyword: keyword
        });

        httpService.httpRequest(APITarget, Values, 'GET').then(function (data) {
            if (data !== false) {
                if (data === "logout") {
                    $rootScope.userLogout();
                }
                def.resolve(angular.fromJson(data));
            } else {
                def.reject();
            }
        });

        return def.promise;
    }

    function searchDepartments(pageNumber, rowsPerPage, keyword) {
        var def = $q.defer(),
        APITarget = "api/injurydepartment/searchInjuryDepartments",
        Values = JSON.stringify({
            Identifier: $rootScope.user.Identifier,
            SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
            DateOfBirth: $rootScope.user.DateOfBirth,
            IsClaimant: $rootScope.user.IsClaimant,
            PageNumber: pageNumber,
            RowsPerPage: rowsPerPage,
            Keyword: keyword
        });

        httpService.httpRequest(APITarget, Values, 'GET').then(function (data) {
            if (data !== false) {
                if (data === "logout") {
                    $rootScope.userLogout();
                }
                def.resolve(angular.fromJson(data));
            } else {
                def.reject();
            }
        });

        return def.promise;
    }

    function searchBusinessUnits(clientId) {
        var def = $q.defer(),
        APITarget = "api/CostCenter/GetClientBusinessUnits",
        Values = JSON.stringify({
            ClientId: clientId,
        });

        httpService.httpRequest(APITarget, Values, 'GET').then(function (data) {
            if (data !== false) {
                if (data === "logout") {
                    $rootScope.userLogout();
                }
                data = angular.fromJson(data).sort(function(a,b) { return a.DisplayName > b.DisplayName ? 1 : -1;});
                def.resolve(data);
            } else {
                def.reject();
            }
        });

        return def.promise;
    }
}]);//end policySumm